// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyBBXFzxM4Z3sKBZFQ9bEZRiBFWX0h-3kBM",
    authDomain: "miampa-1be3e.firebaseapp.com",
    databaseURL: "https://miampa-1be3e.firebaseio.com",
    projectId: "miampa-1be3e",
    storageBucket: "miampa-1be3e.appspot.com",
    messagingSenderId: "54663139263"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts